













import { Component, Vue, Prop } from "vue-property-decorator";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import 'swiper/dist/css/swiper.css';
import { biHottag, windowHelper } from '@tencent/ppd-base-libs';

let vm:any = null;

@Component({
  components: {
    Swiper,
    SwiperSlide,
  }
})
export default class BannerSwiper extends Vue {
  @Prop() bannerConfigList!: {
    img: string,
    href: string,
  }[]; 

  public self = this;

  get isSingle(){
    return this.bannerConfigList.length === 1;
  }

  public swiperOption: any = {
    // autoHeight: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    // fadeEffect: {
    //   crossFade: false,
    // },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    slidesPerView: 'auto', //重要 可以去swiper搜索
    centeredSlides: true,   //重要
    paginationClickable: true,
    spaceBetween: 12,
    effect: 'left',
    loop: true,
    on: {
      slideChangeTransitionStart: () => {
        let swiper = (vm.$refs.mySwiper as any).swiper;
        if (!swiper) return;
      }
    }
  };

  clkItem(index, realIndex) {
    if (!this.bannerConfigList[realIndex].href) return;
    console.log(index, realIndex);
    this.go(this.bannerConfigList[realIndex].href, realIndex);
  }

  public go(link, index){
    if (!link) return;
    biHottag(`wallet.charity.home.banner_click`, { findex: `${ index + 1 }`});
    windowHelper.redirect(link, 300);
  }
  
  public created(){
    vm = this;
  }
}
